import type { IReview } from '@/entities/review/model/types';

export const adaptReviewToCard = (data: IReview[]): IReview[] => {
  return data.map(review => ({
    ...review,
    reply: review.reply
      ? {
          ...review.reply,
          avatar:
            process.env.NEXT_PUBLIC_ENV === 'dev' ? `https://idoctor.kz/${review.reply.avatar}` : review.reply.avatar,
        }
      : null,
  }));
};
